(function () {
  var attempts = 0;
  var maxAttempts = 60; // retry for up to ~18s to survive slow/async script loading
  var intervalMs = 300;

  function tick() {
    attempts++;
    var $ = window.$$ || window.jQuery;

    if ($) {
      var slideMain = $('div[data-slide-main]');
      if (slideMain.length) {
        if (window.innerWidth < 768) {
          if (slideMain.hasClass('slick-initialized')) {
            return; // already a horizontal slider, nothing more to do
          }
          $('body').trigger('contentMobileMode');
        } else {
          return; // desktop viewport, no fallback needed
        }
      }
    }

    if (attempts < maxAttempts) {
      setTimeout(tick, intervalMs);
    }
  }

  function start() {
    setTimeout(tick, 50);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }

  window.addEventListener('resize', function () {
    var $ = window.$$ || window.jQuery;
    if (!$) return;
    var slideMain = $('div[data-slide-main]');
    if (slideMain.length && window.innerWidth < 768 && !slideMain.hasClass('slick-initialized')) {
      $('body').trigger('contentMobileMode');
    }
  });
})();
